export const BADGE_INNER_POSITION = 'inner';
export const BADGE_OUTER_POSITION = 'outer';
